import { BankKeySetupResponse } from '../types'

export type KeySetupResultProps = {
  keySetupResult: BankKeySetupResponse
}
